import ACTION from '../action_constant';
import {ajaxPost,ajaxGet,ajaxPostWithToken,ajaxGetWithToken} from '../util/ajax';
import API from '../api_config';
import cookie from '../util/cookie';

const postAShipmentActions = {
  clearPostAShipmentDetails : () =>{
    return (dispatch) => {
      dispatch({
          type: ACTION.POST_A_SHIPMENT.CLEAR_SHIPMENT_DETAILS,
          data : {}
      })
    }
  },
  storeAShipmentDetail : (data)=>{
    return (dispatch) =>{
      dispatch({
          type: ACTION.POST_A_SHIPMENT.STORE_POST_A_SHIPMENT_DETAILS,
          data
      })
    }
  },
  getShipmentCategories : () =>{
    return (dispatch) => {
        return ajaxGetWithToken ({
            url: API.getShipmentCategories,
            success: (successData) => {
            },
            error: (error) =>{

            }
        })
    }
  },
  createAshipment : (data,api) =>{
    let URL = API.updateShipment ;
    if(api == "CREATE")
      URL = API.createShipment
    return (dispatch) => {
      return ajaxPostWithToken({
          url : URL,
          data: data,
          success: (data) => {
          },
        error: (error) => {
          }
      })
    }
  },getDefaultDiscount : (params) =>{
    return (dispatch) => {
      return ajaxGetWithToken({
          url : API.getDefaultDiscount+ '?userType=' + params.userType + '&shipmentCost=' + params.shipmentCost,
          success: (data) => {
          },
        error: (error) => {
          }
      })
    }
  }
}

export default postAShipmentActions;



// WEBPACK FOOTER //
// app/post_a_shipment/post_a_shipment_actions.jsx